<template>
  <v-container fluid class="py-0" style="background-color: white">
    <v-row>
      <div class="d-flex flex-row" style="width: 100%">
        <div style="width: 440px; border-right: solid 2px #ddd;">
          <div class="d-flex flex-row justify-center ma-4" style="gap: 12px">
            <TextButton
                style="width: 120px"
                :primary="selectedActive"
                :outlined="!selectedActive"
                :disabled="activeJobs && activeJobs.length === 0"
                @click="onSelectActive"
            >
              選考中
            </TextButton>
            <TextButton
                class="mr-2"
                style="width: 120px"
                :primary="!selectedActive"
                :outlined="selectedActive"
                :disabled="inactiveJobs && inactiveJobs.length === 0"
                @click="onSelectInactive"
            >
              非表示
            </TextButton>
          </div>
          <div style="height: calc(100vh - 200px); overflow-y: auto">
            <MessageJobList
                :jobs="jobs"
                :value="selectedJobId"
                @selectJob="onSelectJob"
            />
          </div>
        </div>
        <div class="d-flex flex-column" style="width: calc(100% - 360px)">
          <MessageJobOverview
              :job="selectedJob"
              :requestor="selectedJob.requestor"
          />
          <div
              id="message-board"
              class="px-2"
              style="height: calc(100vh - 400px); overflow-y: auto;"
          >
            <MessageBoard
                :utterances="utterances"
                candidate
                :company="selectedJob.company"
                :requestor="selectedJob.requestor"
            />
          </div>
          <MessageForm
              :messageId="selectedJob.id"
              candidate
              @post="onPost"
          />
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
import MessageBoard from "@/components/organisms/MessageBoard";
import MessageForm from "@/components/organisms/MessageForm";
import MessageJobList from "@/components/organisms/MessageJobList";
import {mapGetters} from "vuex";
import MessageJobOverview from "@/components/organisms/MessageJobOverview";
import ComponentMixin from "@/components/ComponentMixin";
import ApiMixin from "@/ApiMixin";
export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "CandidateMessagesPage",
  components: {MessageJobOverview, MessageJobList, MessageForm, MessageBoard, TextButton},
  beforeMount() {
    const id = this.$route.params.id
    if (!id && this.jobs.length > 0) {
      const messageId = this.jobs[0].id
      this.go(`/messages/${messageId}`)
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("message", ["activeJobs", "inactiveJobs", "utterances"]),
    jobs() {
      if (this.selectedActive) {
        return this.activeJobs
      } else {
        return this.inactiveJobs
      }
    },
    selectedActive() {
      return this.activeJobs.find(job => job.id === this.selectedJobId) != null
    },
    selectedJobId() {
      const id = this.$route.params.id
      if (id) {
        return id
      }
      if (this.activeJobs && this.activeJobs.length > 0) {
        return this.activeJobs[0].id
      }
      if (this.inactiveJobs && this.inactiveJobs.length > 0) {
        return this.inactiveJobs[0].id
      }
      return null
    },
    selectedJob() {
      if (this.jobs) {
        return this.jobs.find(job => job.id === this.selectedJobId) || {
          company: {},
          job: {},
          data: {}
        };
      }
      return {
        company: {},
        job: {},
        data: {}
      };
    }
  },
  methods: {
    onSelectActive() {
      if (this.activeJobs && this.activeJobs.length > 0) {
        const jobId = this.activeJobs[0].id
        this.go(`/messages/${jobId}`)
      } else {
        this.go(`/messages`)
      }
      this.dispatch("message", "clearUtterances")
    },
    onSelectInactive() {
      if (this.inactiveJobs && this.inactiveJobs.length > 0) {
        const jobId = this.inactiveJobs[0].id
        this.go(`/messages/${jobId}`)
      } else {
        this.go(`/messages`)
      }
      this.dispatch("message", "clearUtterances")
    },
    onPost() {
      const board = document.getElementById('message-board');
      const bottom = board.scrollHeight - board.clientHeight;
      board.scroll(0, bottom)
    },
    onSelectJob(jobId) {
      this.go(`/messages/${jobId}`)
    }
  },
  watch: {
    "user.id": {
      handler: function (value) {
        if (value) {
          this.loadUserMessages(this.user.id)
        }
      },
      immediate: true
    },
    "selectedJob.id": {
      handler: function(value) {
        if (value) {
          this.loadMessageUtterances(value).then(res => {
            res.data.utterances.forEach(utterance => {
              if (utterance.isRead === false) {
                this.updateUtteranceIsRead(this.selectedJob.id, utterance.id, 1, true)
              }
            })
          })
        }
      },
      immediate: true
    },
    utterances: {
      handler: function(value) {
        if (value && value.length > 0) {
          setTimeout(function() {
            const board = document.getElementById('message-board');
            const bottom = board.scrollHeight - board.clientHeight;
            board.scroll(0, bottom)
          }, 100)
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>